"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var EventDispatcher_1 = require("./lib/EventDispatcher");
var mobx_1 = require("mobx");
var interfaces_1 = require("data/interfaces");
var Model = (function () {
    function Model(gate, dataStore) {
        this.gate = gate;
        this.dataStore = dataStore;
        this.dispatcher = new EventDispatcher_1.EventDispatcher();
        this.validateFunctions = {};
        this.executeOneTime = 0;
        this.isTableUserVisible = false;
    }
    Model.prototype.test = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                console.log("PDF Model.test");
                return [2];
            });
        });
    };
    Model.prototype.addValidateFunction = function (key, f) {
        this.validateFunctions[key] = f;
    };
    Model.prototype.removeValidateFunction = function (key) {
        this.validateFunctions[key] = null;
    };
    Model.prototype.validate = function () {
        return __awaiter(this, void 0, void 0, function () {
            var results, key, f, r;
            return __generator(this, function (_a) {
                results = [];
                for (key in this.validateFunctions) {
                    f = this.validateFunctions[key];
                    if (!f) {
                        continue;
                    }
                    r = f();
                    results.push(r);
                }
                if (results.includes(false)) {
                    return [2, false];
                }
                return [2, true];
            });
        });
    };
    Model.prototype.edularCoreSignIn = function (credentials) {
        return __awaiter(this, void 0, void 0, function () {
            var newCredentials, r, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        newCredentials = __assign(__assign({}, credentials), { slug: process.env.SLUG });
                        return [4, this.gate.request("/v3/sign-in", {
                                data: newCredentials
                            })];
                    case 1:
                        r = _a.sent();
                        if (r.success) {
                            this.user = r.data;
                            this.json_data = this.user.json_data;
                            this.json_data.type = this.user.type;
                            if (this.user.type === interfaces_1.UserProfileType.Staff) {
                                this.json_data.advisor_name = this.user.firstName + " " + this.user.lastName;
                                this.json_data.advisor_email = this.user.email;
                                this.json_data.link = "" + process.env.BASE_DOMAIN;
                                this.json_data.user_staff_id = "" + this.user.userId;
                                this.json_data.x_profile_staff_id = "" + this.user.profileId;
                            }
                            else {
                                this.json_data.user_student_id = "" + this.user.userId;
                                this.json_data.x_profile_student_id = "" + this.user.profileId;
                            }
                            this.dispatcher.dispatch();
                        }
                        return [2, r];
                    case 2:
                        error_1 = _a.sent();
                        console.log("some error with signIn", error_1);
                        return [3, 3];
                    case 3: return [2];
                }
            });
        });
    };
    Model.prototype.searchStudent = function (search) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, userId, profileId, options, r, error_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        _a = this.user, userId = _a.userId, profileId = _a.profileId;
                        options = {
                            slug: process.env.SLUG,
                            user_id: userId,
                            x_profile_id: profileId,
                            search: search
                        };
                        return [4, this.gate.request("/v3/search-student", {
                                data: options
                            })];
                    case 1:
                        r = _b.sent();
                        if (r.success) {
                            this.userList = r.data;
                            if (r.data.length <= 0) {
                                this.json_data.full_name = "";
                                this.json_data.first_name = "";
                                this.json_data.last_name = "";
                                this.json_data.email = "";
                                this.json_data.address = "";
                                this.json_data.city = "";
                                this.json_data.zip = "";
                                this.json_data.cell_phone = "";
                                this.json_data.start_date = "";
                                this.json_data.program = "";
                            }
                            this.isTableUserVisible = true;
                            this.dispatcher.dispatch();
                        }
                        return [2, r];
                    case 2:
                        error_2 = _b.sent();
                        console.log("some error with searchStudent", error_2);
                        return [3, 3];
                    case 3: return [2];
                }
            });
        });
    };
    Model.prototype.getApiKeyBySlug = function () {
        return __awaiter(this, void 0, void 0, function () {
            var options, r, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        options = {
                            slug: process.env.SLUG
                        };
                        return [4, this.gate.request("/v3/api/key/credentials", {
                                data: options
                            })];
                    case 1:
                        r = _a.sent();
                        if (r.success) {
                            this.user = r.data;
                            if (Object.keys(r.data).length > 0) {
                                this.json_data.api_key_user_id = r.data.userId;
                                this.json_data.api_key_profile_id = r.data.profileId;
                                this.json_data.profile = r.data.profile;
                                this.json_data.type = r.data.type;
                            }
                            this.dispatcher.dispatch();
                        }
                        return [2, r];
                    case 2:
                        error_3 = _a.sent();
                        console.log("some error with getApiKeyBySlug", error_3);
                        return [3, 3];
                    case 3: return [2];
                }
            });
        });
    };
    Model.prototype.getAdvisorsByRoleAndCampus = function () {
        return __awaiter(this, void 0, void 0, function () {
            var options, r, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        options = {
                            slug: process.env.SLUG
                        };
                        return [4, this.gate.request("/v3/users/staff/advisors", {
                                data: options
                            })];
                    case 1:
                        r = _a.sent();
                        if (r.success) {
                            return [2, r.data];
                        }
                        return [3, 3];
                    case 2:
                        error_4 = _a.sent();
                        console.log("some error with getApiKeyBySlug", error_4);
                        return [3, 3];
                    case 3: return [2];
                }
            });
        });
    };
    Model.prototype.getTaskUserInformation = function () {
        return __awaiter(this, void 0, void 0, function () {
            var options, r, error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        options = __assign({}, this.urlQueryParams);
                        return [4, this.gate.request("/v3/tasks/by-user", {
                                data: options
                            })];
                    case 1:
                        r = _a.sent();
                        if (r.success) {
                            this.user = r.data;
                            if (Object.keys(r.data).length > 0) {
                                this.json_data = r.data.json_data;
                                this.json_data.type = r.data.type;
                                this.json_data.user_id = r.data.user_id;
                                this.json_data.x_profile_id = r.data.x_profile_id;
                                this.json_data.task_id = r.data.task_id;
                                this.json_data.task_user_id = r.data.task_user_id;
                                this.json_data.sl = r.data.sl;
                            }
                            this.dispatcher.dispatch();
                        }
                        return [2, r];
                    case 2:
                        error_5 = _a.sent();
                        console.log("some error with getApiKeyBySlug", error_5);
                        return [3, 3];
                    case 3: return [2];
                }
            });
        });
    };
    Model.prototype.searchEmail = function (search) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, userId, profileId, options, r, student, error_6;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        _a = this.adminCredentials, userId = _a.userId, profileId = _a.profileId;
                        options = {
                            slug: process.env.SLUG,
                            user_id: userId,
                            x_profile_id: profileId,
                            email: search
                        };
                        return [4, this.gate.request("/v3/users/search-by-email", {
                                data: options
                            })];
                    case 1:
                        r = _b.sent();
                        if (r.success) {
                            this.user = r.data.length > 0 ? r.data[0] : {};
                            if (r.data.length > 0) {
                                student = r.data[0];
                                this.json_data.first_name = student.firstName;
                                this.json_data.last_name = student.lastName;
                                this.json_data.email = student.email;
                                this.json_data.cell_phone = student.phone;
                                this.json_data.type = student.type;
                            }
                            else {
                                this.json_data.first_name = "";
                                this.json_data.last_name = "";
                                this.json_data.cell_phone = "";
                                this.json_data.parent_name = "";
                                this.json_data.parent_email = "";
                                delete this.json_data.has18;
                            }
                            this.dispatcher.dispatch();
                        }
                        return [2, r];
                    case 2:
                        error_6 = _b.sent();
                        console.log("some error with searchEmail", error_6);
                        return [3, 3];
                    case 3: return [2];
                }
            });
        });
    };
    __decorate([
        mobx_1.observable
    ], Model.prototype, "executeOneTime", void 0);
    __decorate([
        mobx_1.observable
    ], Model.prototype, "adminCredentials", void 0);
    __decorate([
        mobx_1.observable
    ], Model.prototype, "user", void 0);
    __decorate([
        mobx_1.observable
    ], Model.prototype, "urlQueryParams", void 0);
    __decorate([
        mobx_1.observable
    ], Model.prototype, "userList", void 0);
    __decorate([
        mobx_1.observable
    ], Model.prototype, "isTableUserVisible", void 0);
    return Model;
}());
exports.Model = Model;
//# sourceMappingURL=data:application/json;base64,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